import { Badge } from "@shopify/polaris";
import { CircleTickMajor } from "@shopify/polaris-icons";

export default function CompletedBadge() {
  return (
    <Badge status="success" icon={CircleTickMajor}>
      Completed
    </Badge>
  );
}
